export const TEXT_MAX_LENGTH = 512;

export default {
  'Not at all':    'Not at all',
  'Somewhat':      'Somewhat',
  'Significantly': 'Significantly',
  'Not a goal':    'Not a goal of this activity'
}
